import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type SailingsByRouteIDInput,
  sailingsByRouteIDInputSchema,
} from "./shared/sailings.input";
import { type Sailing, sailingSchema } from "./shared/sailings.output";

/**
 * Metadata for the fetchSailingsByRouteID endpoint
 */
export const sailingsByRouteIDMeta = {
  functionName: "fetchSailingsByRouteID",
  endpoint: "/sailings/{SchedRouteID}",
  inputSchema: sailingsByRouteIDInputSchema,
  outputSchema: sailingSchema.array(),
  sampleParams: { SchedRouteID: 2401 },
  endpointDescription: "List active sailings for specified scheduled route.",
} satisfies EndpointMeta<SailingsByRouteIDInput, Sailing[]>;

/**
 * Fetch function for retrieving active sailings for specified scheduled route
 */
const { fetch, useHook } = createFetchAndHook<
  SailingsByRouteIDInput,
  Sailing[]
>({
  api: wsfScheduleApiMeta,
  endpoint: sailingsByRouteIDMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/sailings.endpoints").sailingsGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving active sailings for specified scheduled route
 */
export const fetchSailingsByRouteID: FetchFactory<
  SailingsByRouteIDInput,
  Sailing[]
> = fetch;

/**
 * React Query hook for retrieving active sailings for specified scheduled route
 */
export const useSailingsByRouteID: HookFactory<
  SailingsByRouteIDInput,
  Sailing[]
> = useHook;
